import React, { use, useEffect,useState } from 'react';
import { FiMapPin, FiBriefcase, FiClock, FiGlobe, FiBookmark, FiCheck } from 'react-icons/fi';
import { X, MapPin, Briefcase, Calendar, Clock, Globe, Award, CheckCircle,Factory, Tag} from 'lucide-react';
import { FaStar } from 'react-icons/fa';
import { resumeUpload } from "../../../supports/resumeUpload";


const JobCard = ({ myjob,onApplyJob,isValidate,applyingJobId,candidateId,resumecandidate }) => {
  const isLoading = applyingJobId === myjob?.id;
  const detailIconStyles = 'mph-primary';
  const applied = myjob?.is_applied;
  const [job,setJob]=useState(myjob)
  const[ismodal,setIsModal]=useState(false)
  const [isExpanded, setIsExpanded] = useState(false);
  const [showAllLanguages, setShowAllLanguages] = useState(false);
  const MAX_LENGTH = 600; // Number of characters to show before "Read more"
const description = job?.crm_job_description || '';
const truncatedDescription = description.length > MAX_LENGTH
  ? description.slice(0, MAX_LENGTH) + '...'
  : description;

  const toArray = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'string') {
      return value
        .split(/\n|,|;/)
        .map((item) => item.trim())
        .filter(Boolean);
    }
    return [];
  };

  const qualificationItems =
    toArray(job?.education_requirements).length > 0
      ? toArray(job?.education_requirements)
      : toArray(job?.qualifications);

  const responsibilityItems =
    toArray(job?.capabilities?.capabilities).length > 0
      ? toArray(job?.capabilities?.capabilities)
      : toArray(job?.responsibilities);

  const skillItems = toArray(job?.skills_required);


  useEffect(()=>{
  setJob(myjob)
  },[myjob,job])
  const openJobDetails=async (job)=>{
  try {

     console.log('open job details for',job)
      setIsModal(true)
     let requestBody={
      job_id:job.id,
      candidate_id:candidateId?candidateId:resumecandidate,
     }

     if(candidateId || resumecandidate){
     let response= await resumeUpload.candidateIdView(requestBody) 
     }
   
   
  } catch (error) {
    console.log(error)
  }
}

const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date)) return "";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

function cleanDescription(description) {
  if (!description) return "";

  return description
    .replace(/\|.*?\|/g, "") // remove table rows
    .replace(/(\*\*|---)/g, "") // remove bold and horizontal rules
    .replace(/\n{2,}/g, "\n\n") // reduce multiple newlines
    .trim();
}
 
 
  return (
    <div  onClick={()=>openJobDetails(job)} className="p-4 rounded-xl cursor-pointer flex flex-col bg-white gap-3 hover:shadow-lg shadow-md transition-shadow duration-200  ">
      <div className="flex justify-between items-start">
        <div>
          <div className="font-bold text-gray-333">{job?.title}</div>
            {job?.mph_jobid && (
            <p className="text-sm text-gray-700 flex items-center gap-2 mt-1 font-semibold">
              <Tag size={14} className={`${detailIconStyles} flex-shrink-0`} />
              {job?.mph_jobid}
            </p>
          )}
      
        </div>
        {job?.match_percentage&&(
        <p className="font-bold text-gray-333 flex items-center gap-1 text-sm flex-shrink-0 ml-4">
          <FaStar className='mph-primary'/> {job?.match_percentage}%
        </p>
        )}
      </div>

      <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-gray-666">

          {job?.company_name && (
            <p className="hidden items-center gap-2">
              <FiBriefcase size={14} className={`${detailIconStyles} flex-shrink-0`} />
              {job?.company_name}
            </p>
          )}


       <div className="flex items-center gap-2">
  <FiMapPin size={14} className={`${detailIconStyles} flex-shrink-0`} />
  {job?.city}
  {job?.country ? ` (${job.country})` : ""}
</div>
        {job?.experience_min?(<div className="flex items-center gap-2"><FiClock size={14} className={detailIconStyles} /> {job?.experience_min} years</div>):(
          <div className="flex items-center gap-2"><FiClock size={14} className={detailIconStyles} /> {job?.experience_min} N/A</div>
        )}
     
        {job?.employment_type!=="Not Applicable" && job?.employment_type!=='' ?(
       <div className="flex items-center gap-2">
  <FiBriefcase size={14} className={`${detailIconStyles} flex-shrink-0`} />
  {job?.employment_type}
</div>
        ): <div className="flex items-center gap-2"><FiBriefcase size={14} className={detailIconStyles} />{job?.employment_type}</div>}
     {job?.preferred_languages && job?.preferred_languages.length > 0 && (
  <div  onClick={(e) => {
            e.stopPropagation();
            setShowAllLanguages(!showAllLanguages);
          }} className="flex items-center gap-2">
    <FiGlobe size={14} className={`${detailIconStyles} flex-shrink-0`} />
    <div className="flex items-center gap-1">
      <span>
        {showAllLanguages
          ? job.preferred_languages.map(lang => lang.libelle).join(', ')
          : job.preferred_languages[0].libelle}
      </span>
      {job.preferred_languages.length > 1 && (
        <button

          className="mph-primary text-xs font-medium ml-1"
        >
          {showAllLanguages 
            ? ''
            : `+${job.preferred_languages.length - 1}`}
        </button>
      )}
    </div>
  </div>
)}


<div className="flex items-center gap-2">
  <Factory size={14} className={detailIconStyles} /> {job?.sector_name || 'N/A'}
</div>

      </div>
      
      {job?.vacancy > 0 && !job?.application_status ?
        <div><span className="mph-light mph-primary text-xs font-semibold px-2.5 py-1 rounded-md">{job?.vacancy} Vacancies</span></div>:
        <div><span className="mph-light mph-primary text-xs font-semibold px-2.5 py-1 rounded-md">{job?.application_status}</span></div>
      }

      <div className="border-t border-gray-100 pt-3 mt-auto flex justify-between items-center">
        <span className="text-xs text-gray-999">{formatDate(job?.posted_date)} </span>
        <div className="flex items-center gap-2">
          
          {/* {!job?.application_status && (
          <button  className="h-8 w-8 flex items-center justify-center rounded-full shadow-md mph-primary">
            <FiBookmark size={16}/>
          </button>
          )} */}
          <button  onClick={(e) => {
    e.stopPropagation();   // Prevents triggering openJobDetails
    onApplyJob(job);
  }}
            disabled={job?.application_status }
            className={`flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full profiler-bg ${
              job?.application_status 
              ? 'cursor-not-allowed opacity-50' 
              : 'cursor-pointer'
            }`}
          >
           {!job?.apply && (
  <span className="flex items-center gap-1">
    <FiCheck size={16} />
    {job?.application_status ? 'Applied' : 'Apply now'}
  </span>
)}
          </button>
        </div>
      </div>
           {ismodal&&( 
      <div className='w-full h-full absolute top-0 left-0 flex items-center justify-center bg-white bg-opacity-60 rounded-xl' >
    <div className="bg-white rounded-xl z-[100] shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden transform scale-[0.8] 2xl:scale-100 xl:scale-100 lg:scale-100 ">
        {/* Header with Gradient */}
        <div className="relative bg-gray-400 text-white px-6 py-4">
        
          
          <div className='flex flex-col gap-1 '>
            <h2 className="text-lg font-bold leading-tight">
              {job?.title || 'Not mentioned'}
            </h2>
            <div className='flex gap-2 '>
              <p className="text-sm text-blue-100 ">{job?.company_name }</p> 
              <div className="flex items-center justify-center w-fit bg-white bg-opacity-20 rounded-full px-3 py-1 text-[0.6rem] font-medium ">
                {job?.vacancy || 'Not mentioned'} Vacancies Available
              </div>
            </div>
            {/* <p className="text-xs text-blue-200">Job ID: #{job?.id || 'Not mentioned'}</p> */}
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="px-6 py-4 overflow-y-auto" style={{maxHeight: 'calc(85vh - 150px)'}}>
          {/* Job Overview */}
          <div className="mb-5">
            <h3 className="text-sm font-bold text-gray-900 mb-2 flex items-center gap-2">
              <Briefcase className="w-5 h-5 text-gray-400" />
              Job Overview
            </h3>
            <p className="text-gray-700 leading-relaxed text-xs">
              {isExpanded ? cleanDescription(description) : cleanDescription(truncatedDescription)}
              {description.length > MAX_LENGTH && (
                <span
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="text-[#B2853D] cursor-pointer ml-1"
                >
                  {isExpanded ? ' Show less' : ' Read more'}
                </span>
              )}
              {/* Fallback for the description itself, though usually handled by the component state */}
              {(!description || description.length === 0) && 'Not mentioned'}
            </p>
          </div>

          {/* Position Details */}
          <div className="mb-5">
            <h3 className="text-sm font-bold text-gray-900 mb-3">Position Details</h3>
            <div className="bg-gradient-to-br from-gray-50 to-blue-100 rounded-lg p-4 space-y-3">
              <div className="flex items-start gap-3">
                <div className="bg-[#b0d3d2] rounded-md p-1.5">
                  <MapPin className="w-3 h-3 text-white" />
                </div>
                <div>
                  <p className="text-xs font-medium text-gray-500">Location</p>
                  <p className="text-xs text-gray-900 font-semibold">{job.city || 'Not mentioned'}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="bg-[#b0d3d2] rounded-md p-1.5">
                  <Clock className="w-3 h-3 text-white" />
                </div>
                <div>
                  <p className="text-xs font-medium text-gray-500">Employment Type</p>
                  <p className="text-xs text-gray-900 font-semibold">{job?.employment_type || 'Not mentioned'}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="bg-[#b0d3d2] rounded-md p-1.5">
                  <Award className="w-3 h-3 text-white" />
                </div>
                <div>
                  <p className="text-xs font-medium text-gray-500">Required Experience</p>
                  <p className="text-xs text-gray-900 font-semibold">Minimum {job?.experience_min ? `${job.experience_min} years` : 'Not mentioned'}</p>
                </div>
              </div>
                {job?.preferred_languages && job?.preferred_languages.length > 0 && (
                  <div className="flex items-start gap-3">
                    <div className="bg-[#b0d3d2] rounded-md p-1.5">
                      <Globe className="w-3 h-3 text-white" />
                    </div>
                    
                    <div>
                      <p className="text-xs font-medium text-gray-500">Language Requirements</p>
                      <p className="text-xs text-gray-900 font-semibold">
                        {job?.preferred_languages[0]?.language || 'Not mentioned'} - {job?.preferred_languages[0]?.proficiency || 'Not mentioned'}
                      </p>
                    </div>
                  
                  </div>
                    )}
                {(!job?.preferred_languages || job.preferred_languages.length === 0) && (
                    <div className="flex items-start gap-3">
                        <div className="bg-[#b0d3d2] rounded-md p-1.5">
                            <Globe className="w-3 h-3 text-white" />
                        </div>
                        <div>
                            <p className="text-xs font-medium text-gray-500">Language Requirements</p>
                            <p className="text-xs text-gray-900 font-semibold">Not mentioned</p>
                        </div>
                    </div>
                )}
            </div>
          </div>

          {/* Requirements */}
          <div className="mb-5">
            <h3 className="text-sm font-bold text-gray-900 mb-3">Key Qualification</h3>
            {qualificationItems.length > 0 ? (
                <div className="space-y-2 mt-1">
                    {qualificationItems.map((item, index) => (
                      <div key={`req-${index}`} className="flex items-start gap-2 p-3 bg-white border-l-4 border-[#b0d3d2] rounded-md shadow-sm">
                        <CheckCircle className="w-4 h-4 text-[#03644d] mt-0.5 flex-shrink-0" />
                        <p className="text-xs text-gray-700">{item || 'Not mentioned'}</p>
                      </div>
                    ))}
                </div>
            ) : (
                <p className="text-xs text-gray-700 italic">Not mentioned</p>
            )}
          </div>

          {/* Responsibilities */}
          <div className="mb-5">
            <h3 className="text-sm font-bold text-gray-900 mb-3">Responsibilities and skills</h3>

            {responsibilityItems.length > 0 || skillItems.length > 0 ? (
                <div className="space-y-3">
                    {responsibilityItems.length > 0 && (
                      <div className="grid grid-cols-2 gap-3">
                        {responsibilityItems.map((item, index) => (
                          <div 
                            key={`resp-${index}`}
                            className="bg-gradient-to-br from-blue-50 to-indigo-50 p-4 rounded-lg"
                          >
                            <p className="text-xs text-gray-700">
                              {item || 'Not mentioned'}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
            ) : (
                <p className="text-xs text-gray-700 italic">Not mentioned</p>
            )}
          </div>

          {/* <div className="mb-5">
            <h3 className="text-sm font-bold text-gray-900 mb-3">Key Skills</h3>
            {job.skills_required && job.skills_required.length > 0 ? (
                <div className="space-y-2 mt-1">
                    {job.skills_required.map((item, index) => (
                      <div 
                          <div key={`skill-${index}`} className="flex items-start gap-2 p-3 bg-white border-l-4 border-[#b0d3d2] rounded-md shadow-sm">
                          <CheckCircle className="w-4 h-4 text-[#03644d] mt-0.5 flex-shrink-0" />
                          <p className="text-xs text-gray-700">{item || 'Not mentioned'}</p>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-xs text-gray-700 italic">Not mentioned</p>
            )}
          </div> */}
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-t">
          <div className="flex  gap-3 items-center justify-between">
              <button 
              onClick={(e) => {
                e.stopPropagation();
                setIsModal(false);
              }}
              className=" ml-auto py-1.5 px-3 w-auto text-xs rounded-full bg-white border font-semibold "
            >
              Cancel
            </button>
            {/* <button   disabled={job?.application_status }
              className="w-full py-1.5 px-3 w-auto text-xs rounded-full bg-[#8C642A] text-white font-semibold "
            onClick={(e) => {
              e.stopPropagation(); 
              onApplyJob(job);
                setIsModal(false); 
            }}
            >
              Apply Now
            </button> */}
               <button  onClick={(e) => {
    e.stopPropagation();   // Prevents triggering openJobDetails
    onApplyJob(job);
    setIsModal(false); 
  }}
            disabled={job?.application_status }
            className={`flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full profiler-bg ${
              job?.application_status 
              ? 'cursor-not-allowed opacity-50' 
              : 'cursor-pointer'
            }`}
          >
           {!job?.apply && (
  <span className="flex items-center gap-1">
    <FiCheck size={16} />
    {job?.application_status ? 'Applied' : 'Apply now'}
  </span>
)}
          </button>
          </div>
        </div>
    </div>
      </div>)}

    </div>
  );
};

export default JobCard;
